import React from 'react';
import './AdBanner.css';

export const TopAdBanner = () => (
  <div className="ad-top-wrapper">
    <div className="ad-top-banner">
    </div>
  </div>
);

export const LeftAdSpace = () => (
  <aside className="ad-sidebar ad-sidebar-left">
    <div className="ad-sidebar-box">
    </div>
  </aside>
);

export const RightAdSpace = () => (
  <aside className="ad-sidebar ad-sidebar-right">
    <div className="ad-sidebar-box">
    </div>
  </aside>
);

export const PageWithAds = ({ children }) => (
  <div className="page-ads-wrapper">
    <TopAdBanner />
    <div className="page-content-row">
      <LeftAdSpace />
      <main className="page-main">{children}</main>
      <RightAdSpace />
    </div>
  </div>
);

export default PageWithAds;
